import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../components/HomePage.vue';
import ContactPage from '../components/ContactPage.vue';
import AboutPage from '../components/AboutPage.vue';
import OfferEventPage from '../components/OfferEventPage.vue';
import PortfolioPage from '../components/PortfolioPage.vue';
import ShopPage from '@/components/ShopPage.vue';
import PricePage from '@/components/PricePage.vue';
import ProductDetailPage from '@/components/ProductDetailPage.vue';
import CartPage from '@/components/CartPage.vue';
import SummaryCartPage from '@/components/SummaryCartPage.vue';
import PolicyPage from '@/components/PolicyPage.vue';
import RegulationPage from '@/components/RegulationPage.vue';
import RegulationRentPage from '@/components/RegulationRentPage.vue';

const routes = [
  { path: '/', name: 'HomePage', component: HomePage , meta: { title: 'Cocktail Service -  Bary i obsługa barmańska, wypożyczalnia zaopatrzenia barowego' } },
  { path: '/contact', name: 'ContactPage', component: ContactPage , meta: { title: 'Kontakt - Cocktail Service' } },
  { path: '/about', name: 'AboutPage', component: AboutPage , meta: { title: 'O nas - Cocktail Service' } },
  { path: '/event', name: 'EventPage', component: OfferEventPage , meta: { title: 'Oferta eventowa - Cocktail Service' } },
  { path: '/portfolio', name: 'PortfolioPage', component: PortfolioPage , meta: { title: 'Portfolio - Cocktail Service' } },
  { path: '/rent', name: 'ShopPage', component: ShopPage, meta: { title: 'Wypożyczalnia sprzętu barowego i eventowego - Cocktail Service' } },
  { path: '/price', name: 'PricePage', component: PricePage, meta: { title: 'Cennik - Cocktail Service' } },
  { path: '/rent/product/:id', name: 'ProductDetailPage', component: ProductDetailPage, props: true },
  { path: '/cart', name: 'CartPage', component: CartPage },
  { path: '/cart/summary', name: 'SummaryCartPage', component: SummaryCartPage },
  { path: '/policy', name: 'PolicyPage', component: PolicyPage, meta: { title: 'Poliyka prywatności - Cocktail Service' } },
  { path: '/regulation', name: 'RegulationPage', component: RegulationPage, meta: { title: 'Regulamin - Cocktail Service' } },
  { path: '/regulation-rent', name: 'RegulationRentPage', component: RegulationRentPage, meta: { title: 'Regulamin wypożyczalni - Cocktail Service' } }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Cocktail Service';
  
  // Ustawienie dynamicznego opisu
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', to.meta.description || 'Cocktail Service - wypożyczalnia sprzętu barowego w Warszawie.');
  } else {
    const metaTag = document.createElement('meta');
    metaTag.name = "description";
    metaTag.content = to.meta.description || 'Cocktail Service - wypożyczalnia sprzętu barowego w Warszawie.';
    document.head.appendChild(metaTag);
  }

  next();
});

export default router;
